/* eslint-disable react/prop-types */
import dayjs from 'dayjs';
import { useContext, useState } from 'react';
import { UIContext } from '../context/UIContext';

const TermsAndAgreement = ({
  register,
  errors,
  clearErrors,
  resetField,
  disableForm,
  setValue
}) => {
  const [disable, setDisable] = useState(true);
  const { getColorByBrand, formData } = useContext(UIContext);
  const { community } = formData;
  const brandColor = getColorByBrand(community?.brand);

  const handleChange = (e) => {
    resetField('signature');
    e.target.checked && clearErrors('signature');
    setValue('signingOnBehalfAllOccupants', e.target.checked ? true : false);
    setDisable(!e.target.checked);
  };

  return (
    <div className="bg-white border border-[#BABCC0] rounded w-11/12 lg:m-10 m-3 md:m-6 ">
      <div className="m-5 font-proxima">
        <p className="font-proxima text-primary text-sm font-semibold mb-1 md:text-subHeader">
          Terms & Agreement
        </p>
        <div className="text-tiny md:text-sm">
          <p>
            Should I subsequently wish to cancel or extend my notice to a later date, I will contact
            you immediately through a written request. If my apartment has already been re-rented to
            a new resident by that time I make such a request,
          </p>
          <p className="mt-5">
            I understand that it may be impossible for you ( the owner’s agent ) to grant this
            request. I understand that upon rendering this notice, I am still liable under the
            conditions of my present Lease Agreement.
          </p>
        </div>

        <div>
          <div className="flex items-center mt-5  md:mt-10">
            <input
              type="checkbox"
              id="signingOnBehalfAllOccupants"
              aria-label="signingOnBehalfAllOccupants"
              name="signingOnBehalfAllOccupants"
              disabled={disableForm}
              style={{ color: brandColor }}
              {...register('signingOnBehalfAllOccupants', { required: true })}
              onChange={(e) => {
                handleChange(e);
              }}
              className={
                errors?.signingOnBehalfAllOccupants
                  ? 'appearance-none h-4 w-4 rounded-full border border-[#F5222D]'
                  : `appearance-none h-4 w-4 rounded-full border checked:bg-[${brandColor}] text-[${brandColor}] focus:ring-0 disabled:bg-[#BABCC067]`
              }
            />
            <label className="ml-2 text-tiny md:text-sm ">
              <p>I’m signing on behalf of all occupants</p>
            </label>
          </div>
          {errors?.signingOnBehalfAllOccupants && (
            <p className="text-[#F5222D] text-[10px] pt-2">
              Please select the button for agreement
            </p>
          )}
          <div className="text-xs md:text-sm mt-5">
            <label className="block text-sm font-bold mb-2">
              <p className="font-semibold text-xs md:text-sm">
                <span className="text-[#F5222D]">*</span> Electronic Signature{' '}
                <span className=" font-normal italic hidden md:inline-block">
                  (Enter your full legal name)
                </span>
              </p>
              <p className="font-normal  text-tiny italic  inline-block md:hidden">
                (Enter your full legal name)
              </p>
            </label>
            <input
              className={
                errors?.signature
                  ? ' appearance-none border border-[#F5222D] rounded w-full py-2 px-3 md:w-full  lg:w-[85%] text-gray-700 leading-tight focus:outline-none focus:shadow-outline '
                  : ' appearance-none border border-[#BABCC0] rounded w-full py-2 px-3 md:w-full  lg:w-[85%] text-gray-700 leading-tight focus:outline-none focus:shadow-outline disabled:bg-[#BABCC067] disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
              }
              id="signature"
              type="text"
              {...register('signature', { required: true })}
              aria-label="signature"
              maxLength={100}
              disabled={disable || disableForm}
              placeholder="Please Enter…"
            />
            {errors?.signature && (
              <p className="text-[#F5222D] text-[10px] pt-1">
                Please enter your electronic signature
              </p>
            )}
          </div>
          <div className="mt-5">
            <p className="font-semibold md:text-sm">
              <span className="text-[#F5222D]">*</span> Today’s Date
              <span className="font-normal italic hidden md:inline-block pl-1">
                (Submission Date)
              </span>
            </p>
            <span className="font-normal  text-tiny  italic md:hidden ">(Submission Date)</span>
            <div className="mt-2 ml-2">
              <p className="text-xs md:text-sm text-[#525761]">{dayjs().format('MM/DD/YYYY')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndAgreement;
